var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-4 mt-8 flex flex-row justify-center"},[_c('button',{staticClass:"btn",class:{ 'load': _vm.busy },attrs:{"disabled":_vm.busy,"aria-disabled":_vm.busy,"type":"button"},domProps:{"textContent":_vm._s(_vm.updateAccountText)},on:{"click":function($event){return _vm.$emit('updateProfile')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }